// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"6b8dcd03","453":"b8bf077b"}[chunkId] + ".chunk.js";
};